import type { AtelierActorFrame } from '../../shared';
import {weaponMotion,type SuperAction} from '../../shared/weapon-motion';

export {weaponFacingYaw,duelContactSurface,alignDuelContact} from '../../shared/cine/actorContact';
import {duelContactSurface} from '../../shared/cine/actorContact';

/** Local recipe adaptation for direct sword/dagger cuts. The source keeps its
 * leap/pass trajectory; only a smooth 120ms neighbourhood meets the actual
 * opposing surface. Vertical misses must be fixed in the authored pose. */
export function alignTechniqueContact(attacker:AtelierActorFrame,defender:AtelierActorFrame,action:SuperAction,time:number):void {
 if(action!=='solarCleave'&&action!=='shadowDance')return;
 const contacts=weaponMotion(action==='solarCleave'?'sword':'daggers',action).contacts;
 let total=0,dx=0,dz=0;
 for(const [i,at] of contacts.entries()){
  // Solar's second receipt is its delayed crescent flare, not another sword
  // motion. Shadow's six pass receipts alternate the two physical daggers.
  if(action==='solarCleave'&&i>0)continue;
  const u=Math.max(0,1-Math.abs(time-at)/.12),w=u*u*(3-2*u);if(w<=0)continue;
  const tip=attacker.anchors.weaponTips?.[action==='shadowDance'&&i<6?i%2:0];if(!tip)continue;
  const dir=action==='shadowDance'&&i>=2&&i<4?-1:1,target=duelContactSurface(defender,tip[1],dir);
  const toward=dir*(target[0]-tip[0]),aa=attacker.anchors,da=defender.anchors;
  const depth=Math.max(-.7,Math.min(.7,target[2]-tip[2]));
  // A side pass can meet the flank while the torsos remain separated in Z.
  // Use their actual circular cross-section after the proposed depth move,
  // rather than demanding a full diameter of X separation on every flank.
  const depthGap=da.chest[2]-aa.chest[2]-depth;
  const bodyWidth=Math.sqrt(Math.max(0,(aa.torsoRadius+da.torsoRadius)**2-depthGap**2));
  const chestDelta=da.chest[0]-aa.chest[0],requested=dir*Math.max(-.3,toward);
  // The second dagger may land after the actor has passed the target centre.
  // A movement away from that centre improves separation and must not be
  // blocked by a limiter which still assumes the entry side of the pass.
  const bodyLimit=Math.max(0,Math.abs(chestDelta)-bodyWidth);
  const x=requested*chestDelta>0?Math.sign(requested)*Math.min(Math.abs(requested),bodyLimit):requested;
  dx+=x*w;dz+=depth*w;total+=w;
 }
 if(total<=0)return;
 const scale=1/Math.max(1,total);dx*=scale;dz*=scale;
 attacker.model[12]+=dx;attacker.model[14]+=dz;
 for(const p of [attacker.anchors.chest,attacker.anchors.neck,attacker.anchors.head,...attacker.anchors.hands,...attacker.anchors.weaponTips??[],...attacker.anchors.weaponBases??[]]){p[0]+=dx;p[2]+=dz;}
}
